import { useDispatch, useSelector } from "react-redux";
import styled from "styled-components";
 
import PageTopTitle from "../../components/shared/PageTopTitle";
import Button from "../../components/shared/button/Btn";
import { useEffect, useState } from "react";
import SmallSpinner from "../../components/shared/spinners/SmallSpinner";
import InputText from "../../components/shared/input/new/InputText"
import useWindowDimensions from "../../hooks/useWindowSize";
import { getAracMuayeneSorgu, getAracYetkiBelgesiSorgu } from "../../features/uyelerAraclar/uyelerAraclarSlice";


const Container = styled.div`
  width: 100%;

  .wrapper {
    display: flex;
    flex-direction: column;
    width: 100%;

    .content {
      margin: 40px 30px;
      display: flex;
      width: auto;
      flex-direction: column;
      @media (max-width: 1550px) {
        padding: 40px 30px;
        margin: 0;
      }
      .container {
        margin-top: 40px;
        width: auto;
        display: flex;
        justify-content: center;
        align-items: flex-start;
        gap: 20px;

        .grp {
          display: flex;
          flex-direction: column;
          align-items: center;
          justify-content: center;
          gap: 10px;
          width: 240px;

          &:first-child {
            width: auto;
          }

          p {
            font-size: var(--font-size-sm);
            font-weight: var(--font-weight-md);
            text-align: center;
            color: ${({ theme }) => theme.mainTextColor};
          }
        }
      }

      .res-container{

        display: flex;
        flex-direction: column;
        gap: 20px;

      }

      .toplu-excel-container {
        display: flex;
        flex-direction: column;
        align-items: center;
        padding: 30px 40px;
        border-radius: 10px;
        margin: 0 auto;
        margin-top: 40px;

        width: auto;
        background-color: ${({ theme }) => theme.secondaryBgColor};

        h3 {
          font-size: var(--font-size-lg);
          font-weight: var(--font-weight-xl);
          margin-bottom: 45px;
          color: ${({ theme }) => theme.mainTextColor};
          text-align: center;
        }

        .input-grp {
          display: flex;
          align-items: center;

          .file-input-label {
            width: 160px;
            padding: 0 10px;
            line-height: 40px;
            text-align: center;
            height: 40px;
            background-color: ${({ theme }) => theme.utilityBtnBg};
            color: #fff;
            border-radius: 10px;
            border: 1px solid;
            cursor: pointer;
            border-color: ${({ theme }) => theme.mainBorderColor};
          }

          .file-name {
            font-size: 16px;
            font-weight: var(--font-weight-lg);
            color: ${({ theme }) => theme.mainTextColor};
            padding: 0 20px;
          }

          .file-input {
            display: none;
          }
        }
      }
    }
  }

  @media (max-width: 850px){

    .container {
      flex-direction: column;
      align-items: center !important;
    }

    .toplu-excel-container{
      padding: 30px 20px !important;

      .input-grp{
        flex-direction: column;
        align-items: center;
        gap: 20px;
      }

    }

  }
`;
const AracYetkiBelgesiSorgulamaYukIslemleri = () => {
  const dispatch = useDispatch();
  const [isAdmin, setIsAdmin] = useState(null)
  const storage = JSON.parse(localStorage.getItem("isRemember")) ? localStorage : sessionStorage;
  const {
    isLoadingGetAracMuayeneSorgu,
    isLoadingGetAracCezaSorgu,
    isLoadingGetAracYetkiSorgu,
  } = useSelector((state) => state.uyelerAraclar);

  const [plaka, setPlaka] = useState("");

  const [file, setFile] = useState("");
  const {windowDimensions} = useWindowDimensions()

  const handleYetkiSorgula = () => {
    if (plaka) {
      const newPlaka = plaka.replace(/\s/g, "");
      // dispatch(getAracYetkiBelgesiSorgu(newPlaka));
      dispatch(getAracYetkiBelgesiSorgu(newPlaka));
      // dispatch(showModal("aracYetkiBelgesiSorgu"));
    }
  };

  const handleMuayeneSorgula = () => {
    if (plaka) {
      const newPlaka = plaka.replace(/\s/g, "");
      // dispatch(getAracMuayeneSorgu(newPlaka));
      dispatch(getAracMuayeneSorgu(newPlaka));
      // dispatch(showModal("aracMuayeneSorgu"));
    }
  };

  useEffect(() => {
    const user = JSON.parse(storage.getItem("rld"));
    if(user === "db7bb061-0f64-4eae-9c4f-678a7359fd01"){
      setIsAdmin(true)
    }
  },[isAdmin])

  return (
    <Container>
      <div className="wrapper">
        <PageTopTitle title={"Araç Yetki Belge Sorgulama"} position="sticky" />
        <div className="content">
          <div className="container">
            <div className="grp">
              <InputText data={plaka} setData={(e) => setPlaka(e.target.value.replace(/\s/g, '').toUpperCase())} labelText="Plaka" inputWidth={windowDimensions.width > 900 ? "240px" : (windowDimensions.width <= 850 && windowDimensions.width > 600) ? "380px" : windowDimensions.width <= 600 ? "260px" : "180px"} name={"plakaSorgu"}/>
              <p>Plakayı arada boşluk bırakmadan yazınız.</p>
            </div>
            <div className="grp">
              <Button
                color={"#E85446"}
                background={"#fff"}
                width={windowDimensions.width > 900 ? "240px" : (windowDimensions.width <= 850 && windowDimensions.width > 600) ? "380px" : windowDimensions.width <= 600 ? "260px" : "180px"}
                radius={"10px"}
                padding="0 10px"
                handleClick={handleYetkiSorgula}
              >{
                  isLoadingGetAracYetkiSorgu ? (
                    <SmallSpinner
                      size={"20px"}
                      color={"#fff"}
                      bgColor={"#E85446"}
                    />
                  ) : (
                    "Yetki Belgesi Sorgula"
                  )
                }</Button>
            </div>
            <div className="grp">
              <Button
                color={"#E85446"}
                background={"#fff"}
                width={windowDimensions.width > 900 ? "240px" : (windowDimensions.width <= 850 && windowDimensions.width > 600) ? "380px" : windowDimensions.width <= 600 ? "260px" : "180px"}
                radius={"10px"}
                padding="0 10px"
                handleClick={handleMuayeneSorgula}
              >
                {
                  isLoadingGetAracMuayeneSorgu ? (
                    <SmallSpinner
                      size={"20px"}
                      color={"#fff"}
                      bgColor={"#E85446"}
                    />
                  ) : (
                    "Muayene Sorgula"
                  )
                }</Button>
              <p>Araç yetki belgesinde kayıtlı ise sorgulanabilir.</p>
            </div>
            {/* <div className="grp">
                    <Button color={"#F4F4F4"} background={"#0EAC00"} width="220px" radius={"10px"} text={isLoadingGetAracCezaSorgu ? <SmallSpinner size={"20px"} color={"#fff"} bgColor={"#9ded9a"}/>: "Ceza Sorgula"} padding="0 10px" handleClick={handleCezaSorgula}/>
                    <p>Sadece Egeyurt Lojistik adına kesilen cezalar sorgulanabilmektedir.</p>
                </div> */}
          </div>
          {/* {isAdmin &&
            <div className="toplu-excel-container">
            <h3>Excel Listesinden Toplu Araç Yetki Belgesi Sorgulama</h3>
            <div className="input-grp">
              <label className="file-input-label" htmlFor="detayFile">
                Dosya Seç
              </label>
              <div className="file-name">{file.name || "Dosya Seçin"}</div>
              <input
                type="file"
                id="detayFile"
                className="file-input"
                onChange={(e) => setFile(e.target.files[0])}
              />
              <Button
                color={"#E85446"}
                background={"#fff"}
                width="auto"
                radius={"10px"}
                padding="0 20px"
                handleClick={() => {}}
              >{
                  false ? (
                    <SmallSpinner
                      size={"20px"}
                      color={"#fff"}
                      bgColor={"#E85446"}
                    />
                  ) : (
                    "Toplu Yetki Belgesi Sorgula"
                  )
                }</Button>
            </div>
          </div>
          } */}
        </div>
      </div>
    </Container>
  );
};

export default AracYetkiBelgesiSorgulamaYukIslemleri;
